import * as e from "react";
const m = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M15.5 1h-8A2.5 2.5 0 005 3.5v17C5 21.9 6.1 23 7.5 23h8c1.4 0 2.5-1.1 2.5-2.5v-17C18 2.1 16.9 1 15.5 1zm-4 21a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm4.5-4H7V4h9v14z" }));
export {
  m as ReactComponent
};
